import type { FaireRetailerEntity } from "../../entity_types/retailer";

export const r_v79pcsx8up: FaireRetailerEntity = {
  token: "r_v79pcsx8up",
  type: "retailer",
  name: "K&K Visage Beauty Lounge",
  themeTokens: [
    // Top 4 — curated for homepage
    "moissanite-and-sterling-luxury",
    "gilded-beauty-essentials",
    "retro-modern-statements",
    "post-service-impulse-gems",
    // v3 themes (remaining)
    "symbolic-gold-charms",
    "cz-sparkle-and-glam-accents",
    "california-urban-lifestyle",
    "modern-minimalist-jewelry",
    "boho-vintage-accents",
    "non-tarnish-gold-staples",
    "gold-luxe-for-less",
    "tarnish-free-daily-luxe",
    "luxury-impulse-gifts",
    "bohemian-glow-essentials",
    "water-resistant-gold-essentials",
    // v2 themes (Notion) — disabled for v3 prototype
    // "quirky-conversation-starters",
    // "mystic-and-meaningful-tokens",
    // "the-waterproof-gold-standard",
    // "everyday-18k-gold-glow",
    // "modern-vintage-and-charms",
    // "luxe-sparkle-for-less",
    // "everyday-non-tarnish-gold",
    // "affordable-boutique-glamour",
    // "boho-vintage-statement-pieces",
    // "everyday-luxe-gold",
    // "waterproof-glamour",
    // "sparkling-gift-sets",
    // "luxe-gold-under-10",
    // "non-tarnish-waterproof-gems",
    // "boho-chic-statement-rings",
    // v1 themes (FLARE) — disabled for v3 prototype
    // "salon-retail-staples",
    // "athleisure-lounge-refresh",
    // "mother-s-day-giftable-self-care",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
